<template>
  <div>
    <ion-text>
      Adding a credit card makes paying your Stay Seated order easy! We use
      Stripe to securely store your credit card for future purchases.
    </ion-text>
    <div class="ion-text-center ion-margin-top">
      <img
        :src="poweredByStripe"
        alt="Powered By Stripe"
        class="powered-by-stripe"
      />
    </div>
    <ion-list>
      <ion-item>
        <ion-label position="stacked">
          Payment Information
          <ion-text color="danger">*</ion-text>
        </ion-label>
        <div id="card-element"></div>
      </ion-item>
      <ion-item v-if="stripeError" color="danger">
        {{ stripeError }}
      </ion-item>
      <ion-item>
        <ion-label>Make Primary</ion-label>
        <ion-toggle
          color="success"
          @ionChange="isDefault = $event.detail.checked"
          :checked="isDefault || makeDefaultIsDisabledAndOn"
          :disabled="makeDefaultIsDisabledAndOn"
        ></ion-toggle>
      </ion-item>
    </ion-list>
    <div class="ion-padding">
      <form @submit.prevent="handleSaveCard()">
        <submit-button :submitting="submitting">
          Save Card
        </submit-button>
      </form>
    </div>
    <p>
      <small>
        By clicking Save Card, you authorize Stay Seated to send instructions to
        the financial institution that issued your card to take payments from
        your card account in accordance with the terms of our agreement with
        you.
      </small>
    </p>
  </div>
</template>

<script>
import poweredByStripe from "@/assets/images/powered_by_stripe.svg";
import { getPublicKey } from "@/services/Stripe";
import submittable from "@/mixins/submittable";
import errorAlert from "@/ErrorAlert";
import { mapGetters } from "vuex";

let card, stripe;

export default {
  mixins: [submittable],

  data: function() {
    return {
      poweredByStripe,
      stripeError: "",
      secret: "",
      isDefault: false,
      makeDefaultIsDisabledAndOn: false
    };
  },

  async created() {
    // this is not great, because there is some delay, but it sure made the coding easier
    let paymentMethods = await this.$firestore()
      .collection("users")
      .doc(this.user.uid)
      .collection("stripeCards")
      .get();
    if (!paymentMethods.size) {
      this.makeDefaultIsDisabledAndOn = true;
    }

    let createSetupIntent = this.$functions().httpsCallable(
      "createSetupIntent"
    );
    createSetupIntent()
      .then(result => {
        this.secret = result.data.secret;
      })
      .catch(() => {
        errorAlert(
          "Unable to initialize Stripe.  Payment cannot be processed at this time."
        );
      });
  },

  mounted() {
    stripe = window.Stripe(getPublicKey());
    card = stripe.elements().create("card");

    card.mount("#card-element");

    card.addEventListener("change", ({ error }) => {
      if (error) {
        this.stripeError = error.message;
      } else {
        this.stripeError = "";
      }
    });
  },

  methods: {
    handleSaveCard() {
      this.startSubmission();
      stripe
        .confirmCardSetup(this.secret, {
          payment_method: {
            card
          }
        })
        .then(result => {
          if (result.error) {
            this.stripeError = result.error.message;
            this.completeSubmission();
          } else {
            let addStripeCard = this.$functions().httpsCallable(
              "addStripeCard"
            );

            return addStripeCard({
              stripePaymentId: result.setupIntent.payment_method,
              isDefault: this.isDefault
            })
              .then(result => {
                this.$emit("complete", result.data);
              })
              .catch(() => {
                errorAlert(
                  "Card stored, but unable to associate with user. Please contact us."
                );
                this.completeSubmission();
              });
          }
        })
        .catch(() => {
          errorAlert("An Unknown error occured during confirming your card.");
          this.completeSubmission();
        });
    }
  },

  computed: {
    ...mapGetters("auth", ["user"])
  }
};
</script>
